import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import { Link, Route } from 'react-router-dom'

import formatTimestamp from 'utils/formatTimestamp'
import { getSiteLastQueue, getLastSiteQueueStatus } from 'modules/queues/selectors'
import { LINKS_LIST_PATH } from 'config'
import { pause, resume, stop } from 'modules/queues/actions'
import { startProcess } from 'modules/sites/actions'
import { queueStatuses, runningStatuses } from 'modules/queues/enum'


class WarmingControls extends Component {
  static propTypes = {
    pause: PropTypes.func.isRequired,
    queueStatus: PropTypes.shape({
      prevKey: PropTypes.string,
      queueId: PropTypes.string.isRequired,
      status: PropTypes.oneOf(queueStatuses),
      timestamp: PropTypes.number,
    }),
    resume: PropTypes.func.isRequired,
    site: PropTypes.shape({
      key: PropTypes.string,
    }),
    startProcess: PropTypes.func.isRequired,
    stop: PropTypes.func.isRequired,
  }

  renderControls() {
    const { queueStatus, pause, resume, site, stop } = this.props
    if (!queueStatus) {
      return null;
    }
    const linksListPath = LINKS_LIST_PATH.replace(':site', site.key)
      .replace(':queue', queueStatus.queueId);
    let statusButton;

    if (queueStatus.status === 'PAUSED') {
      statusButton = (
        <button
          className="btn btn-sm btn-primary"
          onClick={ () => resume(queueStatus.queueId) }>
          <i className="zmdi zmdi-play"/>
        </button>
      )
    }
    else if (queueStatus.status === 'WARMING') {
      statusButton = (
        <button
          className="btn btn-sm btn-primary"
          onClick={ () => pause(queueStatus.queueId) }>
          <i className="zmdi zmdi-pause"/>
        </button>
      );
    }

    return (
      <div className="warm-controls card card-block p-0">
        <Route match="/sites/:site/:dir?/:queueId?">
          { ({ match: { params: { queueId } } }) => {
            return (
              <div className={ classNames('nav-link p-2', { 'active': queueId && queueId === queueStatus.queueId }) }>
                <Link
                  to={ linksListPath }>{ formatTimestamp(queueStatus.timestamp) }</Link>
                <div className="row">
                  <span className="col h6" style={ { margin: '5px 0 0' } }>
                    { queueStatus.status }
                  </span>
                  <span className="col align-self-end text-right">
                    { statusButton }
                    { ['WARMING', 'PAUSED'].indexOf(queueStatus.status) > -1 && <button
                      className="btn btn-sm btn-primary"
                      style={ { marginLeft: '5px' } }
                      onClick={ () => stop(queueStatus.queueId) }>
                      <i className="zmdi zmdi-stop"/>
                    </button> }
                  </span>
                </div>
              </div>
            )
          } }
        </Route>
      </div>
    )
  }

  renderStartLink() {
    return (
      <button
        name="start-button"
        className="btn btn-block btn-primary text-uppercase cursor-pointer"
        onClick={ this.startWarming }>
        Start <i className="zmdi zmdi-hc-lg zmdi-play"/>
      </button>
    )
  }

  startWarming = () => {
    const { startProcess, site } = this.props;
    startProcess(site.key)
  }

  render() {
    const { queueStatus } = this.props;
    if (!queueStatus) {
      return this.renderStartLink();
    }

    const isRunning = queueStatus && runningStatuses.indexOf(queueStatus.status) !== -1;

    return (
      <div className={ classNames('mb-3', { 'nav-pills': isRunning }) }>
        { isRunning ? this.renderControls() : this.renderStartLink() }
      </div>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  queueStatus: getLastSiteQueueStatus,
});

const mapDispatchToProps = {
  pause,
  resume,
  startProcess,
  stop,
};

export default connect(mapStateToProps, mapDispatchToProps)(WarmingControls)



// WEBPACK FOOTER //
// ./src/components/sites/sidebar/warm-controls.js